// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-FormatTextBox-FormatTextBox-module__container-jucQUU","transparent":"src-app-components-forms-FormatTextBox-FormatTextBox-module__transparent-z9Uk7s","readonly":"src-app-components-forms-FormatTextBox-FormatTextBox-module__readonly-GvtZus","viewer":"src-app-components-forms-FormatTextBox-FormatTextBox-module__viewer-wR5_ev"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-FormatTextBox-FormatTextBox-module__container-jucQUU\",\"transparent\":\"src-app-components-forms-FormatTextBox-FormatTextBox-module__transparent-z9Uk7s\",\"readonly\":\"src-app-components-forms-FormatTextBox-FormatTextBox-module__readonly-GvtZus\",\"viewer\":\"src-app-components-forms-FormatTextBox-FormatTextBox-module__viewer-wR5_ev\"}";
        // 1789362522830
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  